module.exports = __webpack_public_path__ + "theme/assets/img/c17237f8491f0ebb88b753be42607a02.png";